import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

const status_opened_config: ITableConfig = {
  columns: [
    {
      name: "Event Date",
      key: "date",
      spanMin: "12rem",
      spanMax: "16rem",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    {
      name: "Event Details",
      key: "event_details",
      spanMin: "12rem",
      spanMax: "12rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].sensitivity",
    },
    {
      name: "User Asked",
      key: "user",
      spanMin: "16rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },
    {
      name: "Admin Requesting",
      key: "request_by",
      spanMin: "16rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].source",
    },
    {
      name: "Requested At",
      key: "asked_at",
      spanMin: "10rem",
      spanMax: "10rem",
      sortable: false,
      filterable: false,
      jsPath: "$[*].name",
    },
    /* {
      name: "Event Type",
      key: "event_type",
      spanMin: "11rem",
      spanMax: "11rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    }, */
    {
      name: "Application",
      key: "application",
      spanMin: "7rem",
      spanMax: "7rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].application",
    },
    {
      name: "Severity",
      key: "severity",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].label",
    },

    {
      name: "Status",
      key: "status",
      spanMin: "8rem",
      spanMax: "8rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
      jsPath: "$[*].status",
    },
  ],
};

const status_completed_config: ITableConfig = {
  columns: [
    ...status_opened_config.columns,
    {
      name: "Response",
      key: "",
      spanMin: "6rem",
      spanMax: "6rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};

export const get_table_config = (is_open: boolean) => {
  return is_open ? status_opened_config : status_completed_config;
};
